import { supabase } from './supabase';

export async function getOperators() {
  try {
    const { data } = await supabase.from('bc_operators').select('id,operator_name,data,created_by,updated_at').order('updated_at', { ascending: false });
    return data || [];
  } catch { return []; }
}

export async function getOperator(id) {
  try {
    const { data } = await supabase.from('bc_operators').select('*').eq('id', id).single();
    return data;
  } catch { return null; }
}

export async function saveOperator(operator) {
  const { data: { user } } = await supabase.auth.getUser();
  const payload = {
    operator_name: operator.operatorName || '',
    data: { units: operator.units, operatorName: operator.operatorName },
    created_by: user?.email || '',
    updated_at: new Date().toISOString(),
  };
  if (operator.id) {
    const { data } = await supabase.from('bc_operators').update(payload).eq('id', operator.id).select().single();
    return data;
  } else {
    const { data } = await supabase.from('bc_operators').insert(payload).select().single();
    return data;
  }
}

export async function deleteOperator(id) {
  await supabase.from('bc_operators').delete().eq('id', id);
}
